import { createAsyncThunk } from '@reduxjs/toolkit'

export const modelName = 'commerce'

// TODO: unnecessary reexport
export { default as apiFetch } from 'api/apiFetch'

export { createAsyncThunk }
